import { CHARGER_RATE } from "../enums/chargerRate";

const createChargerRateList = () => {
  const rateList = Object.values(CHARGER_RATE);
  return rateList;
};

export default createChargerRateList;
